import { FolderTree } from 'lucide-react'

/**
 * DataCatalogEmpty displays empty state for data catalog
 */
export function DataCatalogEmpty() {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="rounded-full bg-muted p-6 mb-4">
        <FolderTree className="h-12 w-12 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold mb-2">No data tables found</h3>
      <p className="text-sm text-muted-foreground text-center max-w-md">
        Data tables will appear here after you connect databases and
        discover their schemas via Data Discovery.
      </p>
    </div>
  )
}
